import { styled } from "styled-components";

import { PlusIcon, UIButton } from "common/components";
import { breakpoints } from "common/styles";

export const SourcePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
  row-gap: 1rem;
`;

export const Heading = styled.h1`
  color: ${({ theme }) => theme.colors.textBright};
`;

export const SourcesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const SourcePageLayoutContainer = styled.div`
  display: flex;
  column-gap: 2rem;
  flex-direction: column-reverse;
  row-gap: 1rem;

  @media ${breakpoints.large} {
    flex-direction: row;
  }
`;

export const SourceSearchAndFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const AddButton = styled(UIButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
  aspect-ratio: 1;
  border-radius: 100%;
  padding: 0px;
`;

export const AddIcon = styled(PlusIcon)`
  color: ${({ theme }) => theme.colors.white};
`;

export const SourceListLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  row-gap: 1rem;

  @media ${breakpoints.large} {
    flex: 1;
    min-width: 400px;
  }
`;

export const ScrollableSourceListContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  overflow-y: scroll;
`;
